module.exports = __webpack_public_path__ + "static/flags/UA-44ce42cfd64e6714e7ff19e8e17073de.gif";